// A shared listing is a colleague's listing the user markets; the user is
// NOT the listing agent. The wizard keeps the footer switch fully in the
// user's hands and asks them to confirm before it goes off on such a listing.

export interface SharedListingFlag {
    sharedListing?: boolean | null;
}

/** True only when the listing is explicitly flagged as shared. */
export const isSharedListing = (
    listing: SharedListingFlag | null | undefined,
): boolean => listing?.sharedListing === true;

export const FOOTER_OFF_WARNING_TITLE = "Turn off the footer?";
export const FOOTER_OFF_WARNING_MESSAGE =
    "You're marketing this listing on behalf of another agent, and the footer is what identifies the listing agent on your posts.";
export const FOOTER_OFF_WARNING_MESSAGE_TWO =
    "You can turn it off, but please make sure your posts still meet your MLS's marketing and attribution standards.";
export const FOOTER_OFF_CONFIRM_TEXT = "Turn off footer";
export const FOOTER_OFF_CANCEL_TEXT = "Keep footer on";
